<template>
    <div class="select-state">
      <b-container>
        <b-row>
          <b-col>
            <div class="info-header align-self-center text-center">
              <b-img
                  class="logo"
                  :src="logo.path"
                  alt="Main Logo"
              />
              <h5>Select your state.</h5>
              <p class="text-subheading">Your state determines the forms you have access to.</p>
            </div>
          </b-col>
        </b-row>

        <b-form
            @submit.prevent="$emit('submit', metaObject)"
        >
          <b-row class="form-row">
            <b-col class="d-md-block"></b-col>
            <b-col cols="12" md="6">
              <label for="state">State</label>

              <custom-select
                  cs-label="text"
                  :clearable="false"
                  :reduce="option => option.value"
                  :options="states"
                  :key="statesCustomSelectKey"
                  :value="value.state"
                  @input="onInputChange($event, 'state')"
              />

              <template v-if="errors.length">
                <b-form-invalid-feedback
                    :key="errIndex"
                    class="d-block"
                    v-for="(error, errIndex) in errors"
                >
                  <i class="fal fa-exclamation-circle"/>
                  {{ error }}
                </b-form-invalid-feedback>
              </template>
            </b-col>
            <b-col class="d-md-block"></b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <div class="d-flex justify-content-center">
                  <b-btn
                      :disabled="loading"
                      pill
                      size="lg"
                      type="button"
                      class="white-button"
                      @click="goBack"
                  >
                    Back
                  </b-btn>
                  &nbsp;
                  <b-btn
                      :disabled="loading"
                      pill
                      size="lg"
                      type="submit"
                      class="gold-button"
                  >
                    Next
                  </b-btn>
                </div>
              </b-form-group>
            </b-col>
          </b-row>

        </b-form>

      </b-container>


    </div>
</template>

<script>
import "./SelectState.scss";
import {runAsPublic} from "@helpers/api-helper";
import {fetchEnabledStates, getV2States} from '@helpers/state';
import {uniqBy} from 'lodash';

export default {
    name: 'SelectState',
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ('')
        },
        errors: {
            type: [Object, Array],
            required: false,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        logo: {
          path: require('@assets/images/ss-wordmark-black.png'),
        },
        states: [],
        dataStates: [],
        statesCustomSelectKey: 0,
        metaObject: {}
    }),
    methods: {
        onInputChange(value, name) {
            this.value[name] = value;
            this.metaObject = (this.dataStates.find(item => item.id === value) || {}).meta;
        },
        goBack() {
          this.$emit('welcome');
        },
    },
    async beforeCreate() {
        await runAsPublic(async () => {
            let enabledStates = await fetchEnabledStates();
            this.dataStates = enabledStates.toArray();
            let v2States = await getV2States();
            v2States = v2States.map(state => ({value: state.id, text: state.title}));
            enabledStates = enabledStates.toArray().map(state => ({value: state.id, text: state.title}));
            this.states = [...enabledStates, ...v2States];
            this.states = uniqBy(this.states, "value");
            this.states = this.states.sort((a, b) => a.text.localeCompare(b.text));;
            this.statesCustomSelectKey++;
        });
    },

}
</script>

<style scoped>

.info-header {
  margin-bottom: 20px;
}

.form-row {
  width: 100%;
}

.white-button {
  background-color: white;
  color: black;
  border: 1px solid black;
  margin-right: 10px;
}

.gold-button {
  background-color: #d4af37;
  color: white;
}

.custom-select {
  width: 100%;
}
</style>
